import React from 'react';
import { ROLES } from '../../utils/constants';
import PrivateRoute from './PrivateRoute';

const PrivateAdminRoute = ({ component, loggedIn, userRole, ...rest }) => (
    <PrivateRoute component={component} loggedIn={loggedIn} userRole={userRole} requiredRoles={ROLES.ADMIN} {...rest} />
);

export default PrivateAdminRoute;
